import axios from 'axios'
import qs, { StringifyOptions } from 'query-string'

import { authTokenInterceptor } from './axios/interceptors'
import { checkAuthorization } from '../api/functions/authHelpers'
import { SESSION_EXPIRED_EVENT } from './event'
import { BASE_URL } from './../api/config'

const instance = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  paramsSerializer: params => {
    const opts: StringifyOptions = {
      arrayFormat: 'comma',
      skipEmptyString: true,
      skipNull: true
    }

    return qs.stringify(params, opts)
  }
})

instance.interceptors.request.use(authTokenInterceptor())

instance.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response.status === 401) {
      if (window.location.pathname !== '/login') {
        // Temporarily excluding `/content-audit` from auth failure check
        // so that it doesn't redirect to login page
        if (error.response.config.url.includes('/content-audit')) {
          return
        }
        if (checkAuthorization().status === 'error') {
          document.dispatchEvent(SESSION_EXPIRED_EVENT)
          window.localStorage.removeItem('authToken')
          window.localStorage.removeItem('refreshToken')
          window.location.replace('/login')
        }
      }
    } else {
      return Promise.reject(error)
    }
  }
)

export default instance
